import { render, staticRenderFns } from "./VideoMessage.vue?vue&type=template&id=7c543dbe&scoped=true"
import script from "./VideoMessage.vue?vue&type=script&lang=js"
export * from "./VideoMessage.vue?vue&type=script&lang=js"
import style0 from "./VideoMessage.vue?vue&type=style&index=0&id=7c543dbe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c543dbe",
  null
  
)

export default component.exports